
{
  "familyId": "MET-INH-LITER",
  "questions": [
    {
      "id": "MET-INH-LITER-001",
      "familyId": "MET-INH-LITER",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_liter_brug",
      "questionType": "multiple_choice",
      "question": "Hoeveel milliliter is 1,5 liter?",
      "options": ["1.500 ml", "150 ml", "15 ml", "15.000 ml"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "stairs", "data": { "type": "volume", "from": "l", "to": "ml" } }],
      "supportAids": [{ "type": "stairs", "showWhen": "wrong", "data": { "type": "volume", "from": "l", "to": "ml", "value": 1.5, "highlight": true, "showAnimation": true } }],
      "conceptId": "volume_l_to_ml",
      "variantIndex": 1,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": ["met.inhoud-trede-aantal-fout", "met.inhoud-eenheid-verward"]
      },
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Van liter naar milliliter ga je 3 treden naar beneden op het metriek trapje. Elke trede is ×10. Dus: 1,5 × 1.000 = 1.500 ml. Waarom ×1.000? Liter → deciliter (×10) → centiliter (×10) → milliliter (×10) = ×1.000.",
        "solutionSteps": [
          "Bepaal het aantal treden: liter → dl → cl → ml = 3 treden",
          "Elke trede naar beneden is ×10, dus 3 treden = ×1.000",
          "Vermenigvuldig: 1,5 × 1.000 = 1.500 ml"
        ],
        "distractorExplanations": {
          "0": "Goed! 1,5 liter = 1.500 milliliter.",
          "1": "Je bent 2 treden naar beneden gegaan (×100). Van liter naar ml zijn het 3 treden (×1.000).",
          "2": "Je bent maar 1 trede naar beneden gegaan (×10). Van liter naar ml zijn het 3 treden (×1.000).",
          "3": "Je hebt te veel vermenigvuldigd. Van liter naar ml = 3 treden = ×1.000, niet ×10.000."
        }
      }
    },
    {
      "id": "MET-INH-LITER-002",
      "familyId": "MET-INH-LITER",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_liter_brug",
      "questionType": "multiple_choice",
      "question": "Hoeveel liter is 0,5 m³?",
      "options": ["5.000 liter", "50 liter", "500 liter", "5 liter"],
      "correctAnswer": 2,
      "stimulusAids": [{ "type": "stairs", "data": { "type": "volume", "from": "m³", "to": "l" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Kubieke meter naar liter", "content": "1 m³ = 1.000 liter. Dus: 0,5 m³ = 0,5 × 1.000 = 500 liter. Onthoud: 1 m³ is een kubus van 1 m × 1 m × 1 m." } }],
      "conceptId": "volume_m3_to_liter",
      "variantIndex": 2,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": ["met.inhoud-trede-aantal-fout", "met.inhoud-eenheid-verward"]
      },
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "1 kubieke meter = 1.000 liter. Dus 0,5 m³ = 0,5 × 1.000 = 500 liter. Bij kubieke maten is elke stap ×1.000 (i.p.v. ×10 bij gewone lengte).",
        "solutionSteps": [
          "Onthoud de omrekenfactor: 1 m³ = 1.000 liter",
          "Vermenigvuldig: 0,5 × 1.000 = 500 liter",
          "Check: 500 liter is een half bad vol — realistisch ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt te veel vermenigvuldigd. 1 m³ = 1.000 liter (niet 10.000), dus 0,5 m³ = 500 liter.",
          "1": "Je hebt met 100 vermenigvuldigd in plaats van 1.000. 1 m³ = 1.000 liter, dus 0,5 m³ = 500 liter.",
          "2": "Goed! 0,5 × 1.000 = 500 liter.",
          "3": "Je hebt met 10 vermenigvuldigd in plaats van 1.000. 1 m³ = 1.000 liter, dus 0,5 m³ = 500 liter."
        }
      }
    },
    {
      "id": "MET-INH-LITER-003",
      "familyId": "MET-INH-LITER",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_liter_brug",
      "questionType": "multiple_choice",
      "question": "Een bak is 20 cm lang, 10 cm breed en 15 cm hoog. Hoeveel liter past erin?",
      "options": ["30 liter", "3 liter", "300 liter", "0,3 liter"],
      "correctAnswer": 1,
      "stimulusAids": [{ "type": "box3d", "data": { "length": 20, "depth": 10, "height": 15, "showGrid": false, "unit": "cm", "label": "Bak" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Van cm³ naar liter", "content": "Stap 1: bereken de inhoud in cm³: 20 × 10 × 15 = 3.000 cm³. Stap 2: 1 liter = 1.000 cm³, dus 3.000 ÷ 1.000 = 3 liter." } }],
      "conceptId": "volume_box_cm3_to_liter",
      "variantIndex": 3,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": ["met.inhoud-cm3-direct-als-liter", "met.inhoud-trede-aantal-fout"]
      },
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Bereken eerst de inhoud: 20 × 10 × 15 = 3.000 cm³. Reken om: 1 liter = 1.000 cm³, dus 3.000 ÷ 1.000 = 3 liter. Waarom 1.000? 1 liter = 1 dm³ = 10 × 10 × 10 cm = 1.000 cm³.",
        "solutionSteps": [
          "Bereken de inhoud: 20 × 10 × 15 = 3.000 cm³",
          "Onthoud: 1 liter = 1.000 cm³",
          "Reken om: 3.000 ÷ 1.000 = 3 liter",
          "Check: 3 liter is een grote fles — past bij een bak ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt waarschijnlijk vergeten te delen door 1.000. De inhoud is 3.000 cm³ = 3 liter (niet 30).",
          "1": "Goed! 20 × 10 × 15 = 3.000 cm³ = 3 liter.",
          "2": "Je hebt cm³ direct als liter genomen. 1 liter = 1.000 cm³, dus 3.000 ÷ 1.000 = 3 liter.",
          "3": "Je hebt te veel gedeeld. 3.000 cm³ ÷ 1.000 = 3 liter (niet 0,3)."
        }
      }
    },
    {
      "id": "MET-INH-LITER-004",
      "familyId": "MET-INH-LITER",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_liter_brug",
      "questionType": "multiple_choice",
      "question": "Een fles bevat 750 ml sap. Hoeveel deciliter is dat?",
      "options": ["75 dl", "0,75 dl", "750 dl", "7,5 dl"],
      "correctAnswer": 3,
      "stimulusAids": [{ "type": "stairs", "data": { "type": "volume", "from": "ml", "to": "dl" } }],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": { "type": "volume", "from": "ml", "to": "dl", "value": 750, "highlight": true, "showAnimation": true }
        }
      ],
      "conceptId": "volume_ml_to_dl",
      "variantIndex": 4,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": ["met.inhoud-trede-aantal-fout", "met.inhoud-eenheid-verward"]
      },
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Van milliliter naar deciliter ga je 2 treden omhoog. Elke trede omhoog is ÷10. Dus 750 ÷ 100 = 7,5 dl. ml → cl (÷10) → dl (÷10) = ÷100. Check: 7,5 × 100 = 750 ✓.",
        "solutionSteps": [
          "Bepaal het aantal treden: ml → cl → dl = 2 treden omhoog",
          "Elke trede omhoog is ÷10, dus 2 treden = ÷100",
          "Deel: 750 ÷ 100 = 7,5 dl",
          "Check: 7,5 dl × 100 = 750 ml ✓"
        ],
        "distractorExplanations": {
          "0": "Je bent maar 1 trede omhoog gegaan (÷10). Van ml naar dl = 2 treden (÷100). 750 ÷ 100 = 7,5 dl.",
          "1": "Je bent 3 treden omhoog gegaan (÷1.000). Van ml naar dl = 2 treden (÷100). 750 ÷ 100 = 7,5 dl.",
          "2": "Je hebt ml en dl als gelijk genomen. Maar 1 dl = 100 ml. Dus 750 ml = 7,5 dl, niet 750 dl.",
          "3": "Goed! 750 ÷ 100 = 7,5 dl."
        }
      }
    },
    {
      "id": "MET-INH-LITER-005",
      "familyId": "MET-INH-LITER",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_liter_brug",
      "questionType": "fill_in",
      "question": "Een aquarium bevat 60 liter water. Hoeveel milliliter is dat? Typ je antwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["60000", "60.000", "60000 ml", "60.000 ml"],
        "caseSensitive": false,
        "placeholder": "... ml"
      },
      "stimulusAids": [{ "type": "stairs", "data": { "type": "volume", "from": "l", "to": "ml" } }],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": { "type": "volume", "from": "l", "to": "ml", "value": 60, "highlight": true, "showAnimation": true }
        }
      ],
      "conceptId": "volume_l_to_ml_large",
      "variantIndex": 5,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": ["met.inhoud-trede-aantal-fout"]
      },
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Van liter naar milliliter = 3 treden = ×1.000. Dus 60 × 1.000 = 60.000 ml. Logisch: een aquarium bevat veel water.",
        "solutionSteps": [
          "Van liter naar milliliter: 3 treden = ×1.000",
          "60 × 1.000 = 60.000 ml",
          "Check: 60.000 ÷ 1.000 = 60 liter ✓"
        ]
      }
    },
    {
      "id": "MET-INH-LITER-006",
      "familyId": "MET-INH-LITER",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_liter_brug",
      "questionType": "multiple_choice",
      "question": "Een maatbeker kan maximaal 500 ml bevatten. Er zit nu 350 ml water in. Hoeveel deciliter is dat?",
      "options": ["35 dl", "3,5 dl", "0,35 dl", "350 dl"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "measuringCup",
          "data": {
            "maxVolume": 500,
            "currentVolume": 350,
            "unit": "ml",
            "label": "Lees de maatbeker af"
          }
        }
      ],
      "supportAids": [
        {
          "type": "measuringCup",
          "showWhen": "wrong",
          "data": {
            "maxVolume": 500,
            "currentVolume": 350,
            "unit": "ml",
            "label": "350 ml = 3,5 dl"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Milliliter naar deciliter",
            "content": "Van ml naar dl ga je 2 treden omhoog: ÷100. Dus 350 ml ÷ 100 = 3,5 dl. Onthoud: 1 dl = 100 ml.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volume_maatbeker_ml_dl",
      "variantIndex": 6,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": ["met.inhoud-trede-aantal-fout", "met.inhoud-eenheid-verward"]
      },
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De maatbeker toont 350 ml. Van ml naar dl = 2 treden omhoog = ÷100. Dus 350 ÷ 100 = 3,5 dl. Check: 3,5 × 100 = 350 ml ✓",
        "solutionSteps": [
          "Lees de maatbeker af: 350 ml",
          "Van ml naar dl: 2 treden omhoog = ÷100",
          "350 ÷ 100 = 3,5 dl",
          "Check: 3,5 × 100 = 350 ml ✓"
        ],
        "distractorExplanations": {
          "0": "Je bent maar 1 trede omhoog gegaan (÷10 → 35). Van ml naar dl = 2 treden (÷100). 350 ÷ 100 = 3,5 dl.",
          "1": "Goed! 350 ml ÷ 100 = 3,5 dl.",
          "2": "Je bent 3 treden omhoog gegaan (÷1.000 → 0,35). Van ml naar dl = 2 treden (÷100). 350 ÷ 100 = 3,5 dl.",
          "3": "Je hebt ml en dl als gelijk genomen. 1 dl = 100 ml. Dus 350 ml = 3,5 dl, niet 350 dl."
        }
      }
    },
    {
      "id": "MET-INH-LITER-007",
      "familyId": "MET-INH-LITER",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_liter_brug",
      "questionType": "fill_in",
      "question": "Een maatbeker van 1 liter bevat 600 ml water. Hoeveel liter is dat? Typ je antwoord met een komma (bijv. 0,5).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["0,6", "0.6", "0,6 liter", "0,6 l", "0,60"],
        "caseSensitive": false,
        "placeholder": "... liter"
      },
      "stimulusAids": [
        {
          "type": "measuringCup",
          "data": {
            "maxVolume": 1000,
            "currentVolume": 600,
            "unit": "ml",
            "label": "Lees af en reken om naar liter"
          }
        }
      ],
      "supportAids": [
        {
          "type": "measuringCup",
          "showWhen": "wrong",
          "data": {
            "maxVolume": 1000,
            "currentVolume": 600,
            "unit": "ml",
            "label": "600 ml = 0,6 liter"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Milliliter naar liter",
            "content": "1 liter = 1.000 ml. Dus 600 ml = 600 ÷ 1.000 = 0,6 liter. De maatbeker is iets meer dan de helft gevuld.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "volume_maatbeker_ml_liter",
      "variantIndex": 7,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": ["met.inhoud-trede-aantal-fout", "met.inhoud-eenheid-verward"]
      },
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Van ml naar liter = 3 treden = ÷1.000. Dus 600 ÷ 1.000 = 0,6 liter. De maatbeker is 60% gevuld. Check: 0,6 × 1.000 = 600 ml ✓",
        "solutionSteps": [
          "Lees de maatbeker af: 600 ml",
          "Van ml naar liter: ÷1.000",
          "600 ÷ 1.000 = 0,6 liter",
          "Check: 0,6 × 1.000 = 600 ml ✓"
        ]
      }
    }
  ]
}
